<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-search @search="updateList">
				<c-form>
					<c-form-item type="input" label="所属项目" name="project_name"></c-form-item>
					<c-form-item type="input" label="备注说明" name="remark"></c-form-item>
					<c-form-item type="select" label="审批状态" name="state" :options="ledgerStateList"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate v-if="power('7')">
				<c-button icon="add" @click="editHandle()">新建安全台账</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="状态"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="ledgerState[data.state]" :style="{'color': ledgerState[data.state].color}">{{ledgerState[data.state].name}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="安全台账所属项目"
					name="project_name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="备注说明"
					name="remark"
					width="250"
				></c-table-column>
				
				<c-table-column
					label="创建时间"
					name="create_date"
					width="160"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="120"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.state == 4 && power('7')" @click="editHandle(data.id)">重新编辑</c-table-button>
						<c-table-button v-if="data.state == 1 && power('8')" @click="navigateTo('/transact/ledger/detail', {id: data.id}, true)">签署</c-table-button>
						<c-table-button v-else @click="navigateTo('/transact/ledger/detail', {id: data.id}, true)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
		
		<ledger-edit v-if="power('7')" ref="ledgerEdit" @resolve="editSubmitHandle"></ledger-edit>
	</app>
</template>

<script>
	import ledgerEdit from './ledger_edit.vue'
	import {mapState, mapGetters} from 'vuex'
	
	export default {
		components: {
			ledgerEdit
		},
		
		data() {
			return {
				projectList: [],
				currentProjectId: ''
			}
		},
		
		computed: {
			...mapState(['ledgerStateList']),
			...mapGetters(['power', 'ledgerState'])
		},
		
		watch: {
			currentProjectId(val) {
				if (val) {
					this.request({
						url: '/project/detail',
						data: {
							project_id: val
						},
						success: data => {
							this.$refs.editLedgerForm.set({
								yzdw_name: data.project_info.yzdw_name,
								jldw_name: data.project_info.jldw_name,
								zbqy_name: data.project_info.zbqy_name
							});
						}
					});
				}
			}
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList(data) {
				this.$refs.table.load({
					url: '/project/aqtz/list',
					data
				});
			},
			
			editHandle(id) {
				this._edit = !!id;
				this.$refs.ledgerEdit.open(id);
			},
			
			editSubmitHandle() {
				this.$refs.table.update(this._edit ? 0 : 1);
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
